module.exports = "<div layout-margin layout-fill> <tsz-report report-id=$ctrl.reportId layout-fill></tsz-report> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/containers/report-edit/report-edit.html
// module id = 163
// module chunks = 1